import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { $ } from '../../utils/element';

export interface MenuIconsSize {
    font: string;
    circle: string;
}

export interface MenuIconsItemBase {
    icon: string;
    color: string;
}

export interface MenuIconsItem extends MenuIconsItemBase {
    onClick: () => void;
    label: string;
    hover?: boolean;
}

@Component({
    selector: 'skl-menu-icons',
    templateUrl: './menu-icons.component.html',
    imports: [NgClass, NgStyle]
})
export class MenuIconsComponent {
    // bindings
    @Input() public size!: MenuIconsSize;
    @Input() public items: MenuIconsItem[] = [];
    @Input() public main!: MenuIconsItemBase;

    // other
    private $document = $(document);
    public isOpen!: boolean;
    private clickEventName = `click.menu-icons.${uuid()}`;

    public ngOnInit(): void {
        this.$document.on(this.clickEventName, this.onOutsideClick.bind(this));
    }

    public onOutsideClick(e?: Event): void {
        if (!e) return;
        const target = $(e.target as HTMLElement);
        const isInsdie = target.findParent('.js-toggle-menu-icons');
        if (this.isOpen && !isInsdie) {
            this.toggle();
        }
    }

    public close(): void {
        this.isOpen = false;
    }

    public open(): void {
        this.isOpen = true;
    }

    public toggle(): void {
        this.isOpen ? this.close() : this.open();
    }

    public ngOnDestroy(): void {
        this.close();
        this.$document.off(this.clickEventName);
    }

    public getIconStyle(): { width: string; height: string; lineHeight: string; fontSize: string } {
        return {
            width: this.size.circle,
            height: this.size.circle,
            lineHeight: this.size.circle,
            fontSize: this.size.font
        };
    }

    public setListPosition(): { bottom: string } {
        return {
            bottom: this.size.circle
        };
    }

    public onItemClick(callback: () => void): void {
        callback();
        this.toggle();
    }
}
